import { UserI } from "@Interfaces";
import { ICart } from "@Interfaces/Api/cart";
import { CategoryHierarchy, ICategory } from "@Interfaces/Api/category";
import { ApiCore } from "@Services/API/Core";
import { apiProvider } from "@Services/API/Provider";

const url = "cart";
const Cart = new ApiCore<ICart>({
  getAll: true,
  getSingle: true,
  remove: false,
  removeWithoutId: true,
  url: url,
  post: true,
  put: true,
  patch: false,
});

Cart.createCartForGuestUser = (modal: object) => {
  return apiProvider.post(`${url}/guestUser`, modal);
};
Cart.getCartAddedByGuest = (queryParams: any) => {
  return apiProvider.getAll(`${url}/guestUser?${queryParams}`);
};
//     .put(`api/v1/cart/guestUser/${getGuestCartId()}`, { cart })

Cart.putGuestGuest = (id: string, modal: object) => {
  return apiProvider.put(`${url}/guestUser`, id, modal);
};

Cart.getCartAddedByAuthenticateUser = () => {
  return apiProvider.getAll(`${url}/myCart`);
};
export { Cart };
